import { Box, Skeleton } from '@mui/material'
import React from 'react'

interface PortfolioValueSkeletonProps {
  width?: number
  height?: number
  symbolWidth?: number
  symbolHeight?: number
}

export default function PortfolioValueSkeleton({
  width = 120,
  height = 40,
  symbolWidth = 60,
  symbolHeight = 24,
}: PortfolioValueSkeletonProps): React.ReactElement {
  return (
    <Box sx={{ display: 'flex', alignItems: 'baseline', gap: 1 }}>
      <Skeleton variant="text" width={width} height={height} />
      <Skeleton variant="text" width={symbolWidth} height={symbolHeight} />
    </Box>
  )
}
